export const SearchContextDefaultData = {
	query: "",
	category: null,
	sort: "latest",
	per_page: 10
}